<template>
    <div v-if="filter">
        <strong>Current Filters:</strong>
        <div
            v-for="item in checkedAmenityItems"
            class="rounded-none border-r border-blue-500 text-blue-800 text-sm inline py-1 px-2 font-bold text-center whitespace-nowrap align-baseline"
        >
            <span>{{ item.label }}</span>
            <span v-for="sub in item.sub_facilities">
                <span v-if="checkedSubAmenities.includes(sub.id)">
                    {{ sub.name }}</span
                >
            </span>
        </div>
        <div
            v-if="propertySleeps"
            class="rounded-none border-r border-blue-500 text-blue-800 text-sm inline py-1 px-2 font-bold text-center whitespace-nowrap align-baseline"
        >
            Sleeps {{ propertySleeps }}+
        </div>
    </div>
</template>
<script>
import { store } from "./store";

export default {
    name: "FilterSelectedComponent",
    props: ["selectedFilters", "filterSleeps", "facilitiesList"],
    data() {
        return {
            checkedAmenities: [],
            checkedAmenityItems: [],
            checkedSubAmenities: [],
            checkedSubAmenityItems: [],
            propertySleeps: "",
            shared: store,
            filter: false
        };
    },
    mounted() {
        this.getRefined(); // load existing filters
    },
    methods: {
        getCurrent() {
            this.currentamenities = this.shared.currentfilters;
            if (
                !(this.currentamenities.length === 0) ||
                this.shared.propertySleeps
            ) {
                this.filter = true;
            }
        },
        getRefined() {
            // load filters from url and php vars
            let array = [];
            let facArray = this.selectedFilters.split("-s-");
            if (facArray[0]) {
                array = facArray[0].split("-");
            } else {
                array = this.selectedFilters.split("-");
            }
            array = array.map(function(item) {
                return parseInt(item);
            });
            this.checkedAmenities = array.filter(Boolean);
            this.propertySleeps = this.filterSleeps;

            const facilitiesList = [];
            if (this.facilitiesList) {
                Object.keys(this.facilitiesList).forEach(group => {
                    this.facilitiesList[group].sort(
                        (a, b) => a.order - b.order
                    );
                    this.facilitiesList[group].forEach(single => {
                        facilitiesList.push({
                            id: single.id,
                            name: single.name,
                            sub_facilities: single.sub_facilities
                        });
                    });
                });
            }
            const filterArray = this.checkedAmenities.map(item => {
                const container = {};
                const currentFilter = facilitiesList.find(
                    x => x.id === Number(item)
                );
                container.value = currentFilter.id;
                container.label = currentFilter.name;
                container.sub_facilities = currentFilter.sub_facilities;

                return container;
            });
            this.checkedAmenityItems = filterArray;
            if (!(this.checkedAmenities.length === 0) || this.propertySleeps) {
                this.filter = true;
            }

            if (facArray[1]) {
                let subArray = [];
                subArray = facArray[1].split("-");
                subArray = subArray.map(function(item) {
                    return parseInt(item);
                });
                this.checkedSubAmenities = subArray.filter(Boolean);
            }
        }
    }
};
</script>
